<template>
  <el-dialog
    title="为学员购买课程"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    @open="handleOpen"
  >
    <el-form
      ref="addCourseForm"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="选择课程" prop="courseId">
        <el-select
          v-model="formData.courseId"
          placeholder="请选择课程"
          style="width: 100%"
          filterable
          @change="handleCourseChange"
        >
          <el-option
            v-for="course in availableCourses"
            :key="course.id"
            :label="`${course.name} - ¥${course.price}`"
            :value="course.id"
          >
            <span style="float: left">{{ course.name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">
              ¥{{ course.price }}
            </span>
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="课程时长" prop="duration">
        <el-input-number
          v-model="formData.duration"
          :min="30"
          :max="730"
          :step="30"
          controls-position="right"
          style="width: 100%"
        />
        <span style="margin-left: 10px; color: #909399">天</span>
      </el-form-item>

      <el-form-item label="购买价格" prop="price">
        <el-input-number
          v-model="formData.price"
          :min="0"
          :max="9999"
          :precision="2"
          controls-position="right"
          style="width: 100%"
        />
        <span style="margin-left: 10px; color: #909399">元</span>
      </el-form-item>

      <el-form-item label="开始日期" prop="startDate">
        <el-date-picker
          v-model="formData.startDate"
          type="date"
          placeholder="选择日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item label="备注">
        <el-input
          v-model="formData.remark"
          type="textarea"
          :rows="3"
          placeholder="请输入备注信息"
          maxlength="200"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'AddCourseDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    studentId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      submitting: false,
      availableCourses: [],
      formData: {
        courseId: null,
        duration: 180,
        price: 0,
        startDate: '',
        remark: '',
      },
      formRules: {
        courseId: [{ required: true, message: '请选择课程', trigger: 'change' }],
        duration: [{ required: true, message: '请输入课程时长', trigger: 'blur' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
        startDate: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  methods: {
    ...mapActions('student', ['fetchAvailableCourses']),
    ...mapActions('student', ['addStudentCourse']),

    /**
     * 对话框打开时
     */
    async handleOpen() {
      this.resetForm();
      // 设置默认开始日期为今天
      this.formData.startDate = new Date().toISOString().split('T')[0];
      // 加载可用课程
      await this.loadAvailableCourses();
    },

    /**
     * 加载可用课程
     */
    async loadAvailableCourses() {
      try {
        this.availableCourses = await this.fetchAvailableCourses();
      } catch (error) {
        console.error('加载课程列表失败:', error);
        this.$message.error('加载课程列表失败');
      }
    },

    /**
     * 课程改变
     */
    handleCourseChange(courseId) {
      const course = this.availableCourses.find((c) => c.id === courseId);
      if (course) {
        this.formData.price = course.price;
        this.formData.duration = course.duration || 180;
      }
    },

    /**
     * 关闭对话框
     */
    handleClose() {
      this.dialogVisible = false;
      this.resetForm();
    },

    /**
     * 重置表单
     */
    resetForm() {
      this.formData = {
        courseId: null,
        duration: 180,
        price: 0,
        startDate: '',
        remark: '',
      };
      this.$nextTick(() => {
        if (this.$refs.addCourseForm) {
          this.$refs.addCourseForm.clearValidate();
        }
      });
    },

    /**
     * 提交表单
     */
    handleSubmit() {
      this.$refs.addCourseForm.validate(async (valid) => {
        if (!valid) {
          return false;
        }

        this.submitting = true;
        try {
          await this.addStudentCourse(
            this.studentId,
            this.formData.courseId,
            this.formData
          );
          this.$message.success('购买课程成功');
          this.$emit('success');
          this.handleClose();
        } catch (error) {
          console.error('购买课程失败:', error);
          this.$message.error('购买课程失败');
        } finally {
          this.submitting = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>
